import React from 'react';
import { Tooltip as AntTooltip } from 'antd';
import 'antd/lib/tooltip/style/css';
import styles from './tooltip.module.scss';

type Props = {
  children: React.ReactNode;
  tooltip: string;
  position?: 'left' | 'right' | 'top' | 'bottom' | 'topLeft' | 'topRight' | 'bottomLeft' | 'bottomRight' | 'leftTop' | 'leftBottom' | 'rightTop' | 'rightBottom';
  moveX?: number;
  color?: 'black' | 'light';
};

function Tooltip(props: Props) {
  const { 
    children, 
    tooltip, 
    position = 'left', 
    color = 'black'
  } = props;

  // Map our position prop to Ant Design's placement prop
  // Ant Design supports: top, left, right, bottom, topLeft, topRight, bottomLeft, bottomRight, leftTop, leftBottom, rightTop, rightBottom
  const getPlacement = () => {
    return position;
  };

  // If no tooltip text is provided, just render the children
  if (!tooltip) {
    return <>{children}</>;
  }

  return (
    <AntTooltip 
      title={tooltip} 
      placement={getPlacement()}
      color={color === 'black' ? '#274649' : '#ffffff'}
      overlayInnerStyle={{
        ...(color === 'light' ? { color: '#274649', border: '1px solid #e7e7e7' } : {}),
        maxWidth: '200px',
        wordWrap: 'break-word',
        pointerEvents: 'none' // Make the tooltip transparent to mouse events
      }}
      mouseEnterDelay={0.3}
      mouseLeaveDelay={0.2}
      autoAdjustOverflow={true}
    >
      <span className={styles.wrapper}>
        {children}
      </span>
    </AntTooltip>
  );
}

export default Tooltip;
